/** Роли задач «Основы программирования» по маркеру expected_answer. */

export const ROLE_EXPLAIN = 'explain';
export const ROLE_WRITE_PROGRAM = 'write_program';
export const ROLE_ANSWER = 'answer';

export function baseProgRole(expectedAnswer) {
  const a = String(expectedAnswer ?? '').trim();
  if (a === '+') return ROLE_EXPLAIN;
  if (a === '++') return ROLE_WRITE_PROGRAM;
  return ROLE_ANSWER;
}

/** Показывать поле «ваш ответ» / проверку бланка. */
export function showsAnswerBlank(expectedAnswer) {
  return baseProgRole(expectedAnswer) === ROLE_ANSWER;
}

/**
 * Список вариантов эталонного кода: primary + alternative_solutions.
 * @returns {{ label: string, code: string }[]}
 */
export function officialSolutionVariants(task) {
  if (!task) return [];
  const alts = Array.isArray(task.alternative_solutions) ? task.alternative_solutions : [];
  const fromAlts = alts
    .map((item, i) => {
      if (typeof item === 'string') {
        const code = item.trim();
        return code ? { label: `Вариант ${i + 1}`, code } : null;
      }
      if (item && typeof item === 'object') {
        const code = String(item.code ?? '').trim();
        if (!code) return null;
        const label = String(item.label ?? '').trim() || `Вариант ${i + 1}`;
        return { label, code };
      }
      return null;
    })
    .filter(Boolean);

  const primary = String(task.solution_code ?? '').trim();
  if (!primary && fromAlts.length === 0) return [];
  if (!primary) return fromAlts;

  const primaryLabel =
    fromAlts.length > 0 ? 'Вариант 1' : 'Решение';
  const rest = fromAlts.map((v, i) => ({
    ...v,
    label: v.label || `Вариант ${i + 2}`,
  }));
  return [{ label: primaryLabel, code: primary }, ...rest];
}
